import AnimatedContent from './AnimatedContent';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <AnimatedContent
          distance={150}
          direction="vertical"
          reverse={false}
          duration={1.2}
          ease="bounce.out"
          initialOpacity={0.2}
          animateOpacity
          scale={1.1}
          threshold={0.2}
          delay={0.3}
        >
          <h2 className="section-heading">About Me</h2>
        </AnimatedContent>
        <p className="about-text">
          Full-stack developer passionate about creating innovative digital solutions. 
          I build scalable applications that solve real-world problems with modern technologies.
        </p>
        <p className="about-text">
          When not coding: chess, cricket, badminton, and reading novels become my favorite pass time.
        </p>
      </div>
    </section>
  );
};

export default AboutSection;